"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseFanMotorProInputType = parseFanMotorProInputType;
const GraphQLTypes = __importStar(require("@genesys/graphql-types-tools"));
const property_1 = require("@genesys/property");
const calculations_1 = require("@munters/calculations");
const KnownProperties = __importStar(require("./known-properties"));
function parseFanMotorProInputType(pvs, fanCurvePoints) {
    const temperatureIn = property_1.PropertyValueSet.getAmount(KnownProperties.airInputsTemperature, pvs);
    const pressureIn = property_1.PropertyValueSet.getAmount(KnownProperties.airInputsPressure, pvs);
    const relativeHumidity = property_1.PropertyValueSet.getAmount(KnownProperties.airInputsHumidity, pvs);
    const humidityIn = calculations_1.Physics.RP1485.AmountConversions.relativeHumidityToHumidityRatio(pressureIn, temperatureIn, relativeHumidity);
    const flow = property_1.PropertyValueSet.getAmount(KnownProperties.airInputsMassflow, pvs);
    return {
        controlMode: parseControlMode(property_1.PropertyValue.toString(property_1.PropertyValueSet.get(KnownProperties.fanControlMode, pvs))),
        fanDefinition: parseFanMotorProFanDefinitionType(pvs, fanCurvePoints),
        fanOperationalRange: parseFanProFanOperationalRangeInputType(pvs),
        motorDefinition: parseMotorDefinitionType(pvs),
        driveDefinition: parseDriveDefinitionType(pvs),
        driveRatio: property_1.PropertyValue.toString(property_1.PropertyValueSet.get(KnownProperties.driveRatio, pvs)),
        inverterDefinition: parseInverterDefinitionInputType(pvs),
        temperatureIn: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(temperatureIn)),
        humidityIn: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(humidityIn)),
        pressureIn: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(pressureIn)),
        flowIn: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(flow)),
        actualDensity: property_1.PropertyValue.toString(property_1.PropertyValueSet.get(KnownProperties.actualDensity, pvs)),
        fanQuantity: property_1.PropertyValue.toString(property_1.PropertyValueSet.get(KnownProperties.fanQuantity, pvs)),
        targetPressure: property_1.PropertyValue.toString(property_1.PropertyValueSet.get(KnownProperties.targetPressure, pvs))
    };
}
function parseFanMotorProFanDefinitionType(pvs, fanCurvePoints) {
    return {
        definitionSpeed: property_1.PropertyValue.toString(property_1.PropertyValueSet.get(KnownProperties.fanDefinitionSpeed, pvs)),
        definitionStandardDensity: property_1.PropertyValue.toString(property_1.PropertyValueSet.get(KnownProperties.fanDefinitionStandardDensity, pvs)),
        performanceModel: parseFanMotorProPerformanceModelInputType(pvs, fanCurvePoints)
    };
}
function parseFanMotorProPerformanceModelInputType(pvs, fanCurvePoints) {
    const fanCurveRows = fanCurvePoints.map((p) => parseFanCurveRow(p));
    return {
        fanCurveRows: fanCurveRows,
        outletArea: property_1.PropertyValue.toString(property_1.PropertyValueSet.get(KnownProperties.fanOutletArea, pvs)),
        dynamicPressureLossCoefficient: property_1.PropertyValue.toString(property_1.PropertyValueSet.get(KnownProperties.fanDynamicPressureLossCoefficient, pvs))
    };
}
function parseMotorDefinitionType(pvs) {
    return {
        nominalPower: property_1.PropertyValue.toString(property_1.PropertyValueSet.get(KnownProperties.motorNominalPower, pvs)),
        motorPoles: property_1.PropertyValue.toString(property_1.PropertyValueSet.get(KnownProperties.motorPoles, pvs)),
        motorEfficiency: property_1.PropertyValue.toString(property_1.PropertyValueSet.get(KnownProperties.motorEfficiency, pvs)),
        baseFrequency: property_1.PropertyValue.toString(property_1.PropertyValueSet.get(KnownProperties.motorBaseFrequency, pvs)),
        nominalSpeed: property_1.PropertyValue.toString(property_1.PropertyValueSet.get(KnownProperties.motorNominalSpeed, pvs)),
        minimumSpeed: property_1.PropertyValue.toString(property_1.PropertyValueSet.get(KnownProperties.motorMinimumSpeed, pvs)),
        maximumSpeed: property_1.PropertyValue.toString(property_1.PropertyValueSet.get(KnownProperties.motorMaximumSpeed, pvs)),
        lag: property_1.PropertyValue.toString(property_1.PropertyValueSet.get(KnownProperties.motorLag, pvs)),
        voltage: property_1.PropertyValue.toString(property_1.PropertyValueSet.get(KnownProperties.motorVoltage, pvs)),
        phases: property_1.PropertyValue.toString(property_1.PropertyValueSet.get(KnownProperties.motorPhases, pvs)),
        cosPhi: property_1.PropertyValue.toString(property_1.PropertyValueSet.get(KnownProperties.motorCosphi, pvs)),
        overSpeedDerateFactor: property_1.PropertyValue.toString(property_1.PropertyValueSet.get(KnownProperties.motorOverspeedDerateFactor, pvs))
    };
}
function parseControlMode(value) {
    if (value === "1") {
        return GraphQLTypes.FanMotorProControlMode.MODULATE;
    }
    if (value === "2") {
        return GraphQLTypes.FanMotorProControlMode.MAXIMIZE;
    }
    throw new Error(`Invalid ControlMode: ${value}`);
}
function parseDriveDefinitionType(pvs) {
    const rawType = property_1.PropertyValue.toString(property_1.PropertyValueSet.get(KnownProperties.driveType, pvs));
    return {
        type: parseDriveType(rawType),
        efficiency: property_1.PropertyValue.toString(property_1.PropertyValueSet.get(KnownProperties.driveEfficiency, pvs))
    };
}
function parseDriveType(value) {
    if (value === "1") {
        return GraphQLTypes.DriveType.DIRECT;
    }
    if (value === "2") {
        return GraphQLTypes.DriveType.BELT;
    }
    throw new Error(`Invalid DriveType: ${value}`);
}
function parseFanProFanOperationalRangeInputType(pvs) {
    return {
        minimumSpeed: property_1.PropertyValue.toString(property_1.PropertyValueSet.get(KnownProperties.fanMinimumSpeed, pvs)),
        maximumSpeed: property_1.PropertyValue.toString(property_1.PropertyValueSet.get(KnownProperties.fanMaximumSpeed, pvs))
    };
}
function parseInverterDefinitionInputType(pvs) {
    const rawInverter = property_1.PropertyValue.toString(property_1.PropertyValueSet.get(KnownProperties.inverter, pvs));
    return {
        inverter: parseBinaryBoolean(rawInverter),
        efficiency: property_1.PropertyValue.toString(property_1.PropertyValueSet.get(KnownProperties.inverterEfficiency, pvs))
    };
}
function parseBinaryBoolean(value) {
    if (value === "1") {
        return true;
    }
    if (value === "0") {
        return false;
    }
    throw new Error(`Invalid binary boolean value: ${value}`);
}
function parseFanCurveRow(pvs) {
    return {
        airFlow: property_1.PropertyValue.toString(property_1.PropertyValueSet.get(KnownProperties.airFlow, pvs)),
        pressure: property_1.PropertyValue.toString(property_1.PropertyValueSet.get(KnownProperties.pressure, pvs)),
        shaftPower: property_1.PropertyValue.toString(property_1.PropertyValueSet.get(KnownProperties.shaftPower, pvs))
    };
}
//# sourceMappingURL=input-parser.js.map